import { useQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import { api } from '../api';

export function RssPage() {
  const { data: rss, isLoading } = useQuery({
    queryKey: ['rss'],
    queryFn: () => api.getRss(),
  });

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="mx-auto max-w-4xl px-4 pb-20 pt-24 sm:px-6 lg:px-8"
    >
      <header className="mb-8">
        <h1 className="mb-2 flex items-center gap-3 text-3xl font-black text-slate-900 dark:text-star">
          <FileText size={28} className="text-orange-500" /> RSS Feed
        </h1>
        <p className="text-slate-600 dark:text-star-dim">你可以复制下方 XML 地址订阅更新。</p>
      </header>

      <div className="mb-6 overflow-hidden rounded-xl border border-slate-200 bg-white dark:border-indigo-500/20 dark:bg-space-800/60">
        <input
          readOnly
          value={`${import.meta.env.VITE_API_URL || '/api'}/rss.xml`}
          className="w-full bg-transparent px-4 py-3 text-sm text-slate-700 outline-none dark:text-star-dim"
        />
      </div>

      {isLoading ? (
        <div className="h-64 animate-pulse rounded-xl bg-slate-200 dark:bg-space-800"></div>
      ) : (
        <pre className="max-h-[600px] overflow-auto rounded-xl border border-slate-200 bg-slate-50 p-4 text-xs text-slate-700 dark:border-indigo-500/20 dark:bg-space-950 dark:text-star-dim">
          {rss}
        </pre>
      )}
    </motion.div>
  );
}
